import config from "@/config";
import http from "@/utils/request";

export default {
	goods: {
		list: {
			url: `${config.API_URL}/admin/goods/list`,
			name: "获取商品列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, Object.assign(config, { timeout: 300000 }));
			},
		},
		listSimple: {
			url: `${config.API_URL}/admin/goods/listSimple`,
			name: "获取商品列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, Object.assign(config, { timeout: 300000 }));
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/goods/store`,
			name: "新增编辑商品",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/goods/getDetail`,
			name: "获取商品详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		updataStatus: {
			url: `${config.API_URL}/admin/goods/enable`,
			name: "修改商品状态",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/goods/del`,
			name: "删除商品",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		erpList: {
			url: `${config.API_URL}/admin/goods/wsGoodsList`,
			name: "获取erp商品列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		goodsLog: {
			url: `${config.API_URL}/admin/goods/goodsLog`,
			name: "获取商品编辑历史",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	inventory: {
		getGoodsList: {
			url: `${config.API_URL}/admin/inventory/getGoodsList`,
			name: "同步进销存商品",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	brand: {
		list: {
			url: `${config.API_URL}/admin/brand/list`,
			name: "获取品牌列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/brand/store`,
			name: "新增编辑品牌",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/brand/delete`,
			name: "删除品牌",
			delete: async function (data = {}) {
				return await http.delete(this.url, data);
			},
		},
		all: {
			url: `${config.API_URL}/admin/brand/all`,
			name: "获取全部品牌列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	classify: {
		list: {
			url: `${config.API_URL}/admin/category/list`,
			name: "获取分类列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/category/store`,
			name: "新增编辑分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/category/del`,
			name: "删除分类",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		all: {
			url: `${config.API_URL}/admin/category/all`,
			name: "获取全部分类列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	scene: {
		list: {
			url: `${config.API_URL}/admin/goods_scene/index`,
			name: "获取商品场景列表",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/goods_scene/store`,
			name: "新增编辑商品场景",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/goods_scene/show`,
			name: "获取商品场景详情",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updataStatus: {
			url: `${config.API_URL}/admin/goods_scene/enable`,
			name: "启用禁用商品场景",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/goods_scene/del`,
			name: "删除商品场景",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	guarantee: {
		list: {
			url: `${config.API_URL}/admin/goods_service/index`,
			name: "获取保障服务列表",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/goods_service/store`,
			name: "新增编辑保障服务",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/goods_service/show`,
			name: "获取保障服务详情",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updataStatus: {
			url: `${config.API_URL}/admin/goods_service/enable`,
			name: "启用禁用保障服务",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/goods_service/del`,
			name: "删除保障服务",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	purchase: {
			list: {
			url: `${config.API_URL}/admin/purchase_notes/list`,
			name: "购买须知列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addEdit: {
			url: `${config.API_URL}/admin/purchase_notes/store`,
			name: "新增/编辑",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/purchase_notes/del`,
			name: "删除",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/purchase_notes/detail`,
			name: "详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	freight: {
		list: {
			url: `${config.API_URL}/admin/config/areaList`,
			name: "获取运费模板列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/config/editArea`,
			name: "新增编辑运费模板",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	pictorial: {
		list: {
			url: `${config.API_URL}/admin/picture_card/list`,
			name: "获取图鉴列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/picture_card/store`,
			name: "新增编辑图鉴",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/picture_card/detail`,
			name: "获取图鉴详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/picture_card/del`,
			name: "删除图鉴",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
};
